var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_vm._v(" "+_vm._s(_vm.$store.getters.snackBarObj.text)+" "),_c('v-btn',{attrs:{"color":"pink","text":""},on:{"click":_vm.closeSnackBar}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }